/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var essentialStickyFormSelector = [
    'form[id^="essential-sticky-cart-form"]',
    'form[data-essential-cart-elements*="sticky-add-to-cart-form"]',
    'form[action*="/cart/add"][data-essential-cart-elements]'
  ].join(',');

  function getEssentialStickyForm(element) {
    if (!element || !element.closest) return null;

    return element.closest(essentialStickyFormSelector);
  }

  function prepareEssentialStickyForm(form, button) {
    if (!form || !button) return;

    button.setAttribute('data-add-to-cart', '');

    if (!form.hasAttribute('data-product-form')) {
      form.setAttribute('data-product-form', '');
    }

    if (!form.hasAttribute('data-recipient-errors')) {
      form.setAttribute('data-recipient-errors', 'false');
    }

    if (!form.hasAttribute('data-max-inventory-reached')) {
      form.setAttribute('data-max-inventory-reached', 'false');
    }

    if (!form.hasAttribute('data-error-message-position')) {
      form.setAttribute('data-error-message-position', 'form');
    }

    if (!form.querySelector('[data-cart-errors-container]')) {
      var errorContainer = document.createElement('div');
      errorContainer.setAttribute('data-cart-errors-container', '');
      errorContainer.setAttribute('role', 'alert');
      errorContainer.className = 'product__form__errors';
      form.appendChild(errorContainer);
    }
  }

  document.addEventListener(
    'click',
    function(event) {
      var button = event.target.closest && event.target.closest('button, [role="button"], input[type="button"], input[type="submit"]');
      var form = getEssentialStickyForm(button);

      if (!form || !button || button.disabled) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      prepareEssentialStickyForm(form, button);

      document.dispatchEvent(
        new CustomEvent('theme:cart:add', {
          detail: {
            button: button
          },
          bubbles: false
        })
      );
    },
    true
  );

// Open Shop dropdown on mobile nav by default
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    var triggerId = 'MobileNav--shop-0-sections--20705277968570__mobile-menu';
    var container = document.getElementById(triggerId);
    var trigger = document.querySelector('[aria-controls="' + triggerId + '"]');

    if (container) {
      container.classList.add('is-expanded');
      container.style.height = 'auto';
    }

    if (trigger) {
      trigger.classList.add('is-expanded');
      trigger.setAttribute('aria-expanded', 'true');
    }
  }, 300);
});





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
